var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"weirdo-calendar"},[_c('FullCalendar',{ref:"weirdoAppCalendar",staticClass:"weirdo-app-calendar",attrs:{"schedulerLicenseKey":"GPL-My-Project-Is-Open-Source","timeFormat":"DD-MMM-YYYY","height":"parent","locale":_vm.locale,"defaultDate":Date.now(),"allDayDefault":true,"header":{
      left: '',
      center: 'title',
      right: 'prev,next today dayGridMonth'
    },"plugins":_vm.calendarPlugins,"weekends":_vm.calendarWeekends,"navLinks":true,"events":_vm.events,"viewSkeletonRender":_vm.viewSkeletonRender,"viewSkeletonDestroy":_vm.viewSkeletonDestroy,"eventClick":_vm.eventClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }